import Signup from "@auth/pages/signup";
import { object, string } from "zod";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { getUserOptions } from "creso-core/hooks";
import { User } from "creso-core/types";

export const Route = createFileRoute("/(authless)/signup/distributor")({
  beforeLoad: async ({ context }) => {
    const { queryClient } = context;
    let user: User | null = null;
    try {
      user = await queryClient.ensureQueryData(getUserOptions());
    } catch {
      // If me() fails, user is not logged in, which is fine
    }
    // Redirect to home if user is logged in
    if (user) {
      throw redirect({
        to: "/home",
      });
    }
  },
  component: () => <Signup />,
  validateSearch: object({ refer: string().optional() }),
});
